var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignUpMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5378_52580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5378_52580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 40C7.4 40 6.45833 39.6083 5.675 38.825C4.89167 38.0417 4.5 37.1 4.5 36V12C4.5 10.9 4.89167 9.95833 5.675 9.175C6.45833 8.39167 7.4 8 8.5 8H26.5C27.0667 8 27.5417 8.19167 27.925 8.575C28.3083 8.95833 28.5 9.43333 28.5 10C28.5 10.5667 28.3083 11.0417 27.925 11.425C27.5417 11.8083 27.0667 12 26.5 12H8.5V36H40.5V22C40.5 21.4333 40.6917 20.9583 41.075 20.575C41.4583 20.1917 41.9333 20 42.5 20C43.0667 20 43.5417 20.1917 43.925 20.575C44.3083 20.9583 44.5 21.4333 44.5 22V36C44.5 37.1 44.1083 38.0417 43.325 38.825C42.5417 39.6083 41.6 40 40.5 40H8.5ZM24.5 22L30.95 18C31.4167 17.7 31.8583 17.625 32.275 17.775C32.6917 17.925 33.0167 18.1833 33.25 18.55C33.4833 18.9167 33.5667 19.3167 33.5 19.75C33.4333 20.1833 33.1667 20.55 32.7 20.85L25.55 25.35C25.2167 25.55 24.8667 25.65 24.5 25.65C24.1333 25.65 23.7833 25.55 23.45 25.35L8.5 16V12L24.5 22ZM38.5 16C36.8333 16 35.4167 15.4167 34.25 14.25C33.0833 13.0833 32.5 11.6667 32.5 10C32.5 8.33333 33.0833 6.91667 34.25 5.75C35.4167 4.58333 36.8333 4 38.5 4C40.1667 4 41.5833 4.58333 42.75 5.75C43.9167 6.91667 44.5 8.33333 44.5 10C44.5 11.6667 43.9167 13.0833 42.75 14.25C41.5833 15.4167 40.1667 16 38.5 16Z",
    fill: "black",
    fillOpacity: 0.38
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpMessage);
export default __webpack_public_path__ + "static/media/SignUpMessage.feb02188.svg";
export { ForwardRef as ReactComponent };